import React from 'react';
import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { SxProps, Theme } from '@mui/material';

export type ButtonProps = {
  onClick?: () => Promise<void> | null | undefined | void;
  loading?: boolean;
  btnSx?: SxProps<Theme>;
} & Omit<MuiButtonProps, 'onClick'>;

export const Button = ({
  loading,
  btnSx = {},
  ...props
}: ButtonProps): React.ReactElement => {
  return (
    <Box
      sx={{
        position: 'relative',
        ...props.sx,
        width: props.fullWidth ? '100%' : 'auto',
      }}
    >
      <MuiButton
        {...props}
        sx={{ width: '100%', ...btnSx }}
        disabled={props.disabled || loading}
        startIcon={
          loading ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            props.startIcon
          )
        }
      />
    </Box>
  );
};
